import axios from "axios";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import {
  Button,
  Col,
  Divider,
  Modal,
  Row,
  Switch,
  Table,
  Tag,
  Tooltip,
} from "antd";
import {
  ADD_MEDICINE_TO_LIST,
  DELETE_MEDICINE_FROM_LIST,
  PUSH_MED_AT_INDEX_OF,
  RESET_ORDER_DETAIL,
  TOGGLE_FILTER,
} from "../../ActionTypes/ActionTypes";
import DoctorMedLinkUpModal from "./DoctorMedLinkUpModal";
import MedInfoModal from "./MedInfoModal";
import "./ShowAddedMedicines.css";

const { Column } = Table;
const { confirm } = Modal;

//! RFID change

const cartridgeMapRevRFID = {
  E0CCBE9C0E: "1",
  A06E10E937: "2",
  B0FA0DE9AE: "3", //new
  "70D30DE947": "4",
  D0F20BE9C0: "5",
  "30AC0DE978": "6",
  "60110DE995": "7",
  "20810BE943": "8",
  F0210EE936: "9",
  F0180CE90D: "10",
  "000111E9F9": "11", //new
  "50780CE9CD": "12",
  A03610E96F: "13",
  "103F0CE9CA": "14",
  F0840DE990: "15",
  F05B10E952: "16",
  D0F011E9D8: "17",
  "70360DE9A2": "18",
  "602611E9BE": "19",
  "00A70BE945": "20",
  "80360BE954": "21",
  "62B643DC4B": "22",
  "429E43DC43": "23",
  "227642DCCA": "24",
  "325643DCFB": "25",
  D27442DC38: "26",
  "424F45DC94": "27",
  "30BA11E972": "28",
  "62EF42DC13": "29",
  "122244DCA8": "30",
  "020644DC9C": "31",
  "72B242DC5E": "32",
  "92ED42DCE1": "33",
  "302213E9E8": "34",
  "700213E988": "35",
  "024243DCDF": "36", //new
  "92FA42DCF6": "37",
  "02CB45DC50": "38",
  "62B242DC4E": "39",
  "920FDC0849": "40", //new
  "60C012E95B": "41",
  D27149DC36: "42",
  F29A49DCFD: "43",
  C09E12E9A5: "44",
  "92E548DCE3": "45",
  "9283DC8548": "46", //new
  "904B11E923": "47",
  A25A48DC6C: "48",
  A07011E928: "49",
  "12FD47DC74": "50",
  "9257DC5148": "51", //new
  B0E112E9AA: "52",
  "727B47DC92": "53",
  B05D0DE909: "54",
  "30110BE9C3": "55", //new
  "10DC10E935": "56",
  "25347DCCA0": "57",
  F2D747DCBE: "58",
  E2FD49DC8A: "59",
  C0B810E981: "60",
  E01412E90F: "61",
  F03712E93C: "62",
  C05A12E961: "63",
  "809511E9ED": "64",
  C09310AAE9: "65", //new
  "30D80CE90D": "66",
  "607D12E9E6": "67",
  E22C4ADC58: "68",
  "301110E9D8": "69",
  C2F949DCAE: "70",
  D09919E9B9: "71",
  E0CB1FE9DD: "72",
  E05D19E94D: "73",
  "10BD1EE95A": "74",
  F0F21AE9F1: "75",
  "70831EE904": "76",
  "60081FE99E": "77",
  F0361EE931: "78",
  B0B11DE9F5: "79",
  "40921B20E9": "80",
  D02119E901: "81",
  "20D619E906": "82",
  "00601CE995": "83",
  "205D1EE98A": "84",
  E0271BE935: "85",
  F0CF1AE9CC: "86",
  "20EF1BE93D": "87",
  B0571AE914: "88", //new
  "60E31CE976": "89",
  "00BE1CE94B": "90",
  "20531DE987": "91",
  "40B71BE905": "92",
  D08B1DE9AF: "93",
  "70B719E937": "94",
  "70791AE9FA": "95",
  D0081DE92C: "96",
  D09B1AE9B8: "97", //new
  "20561FE980": "98",
  "70E31EE964": "99",
  B0961EE9D1: "100",
  "404B1BE9F9": "101",
  A0D71DE983: "102",
  "607D1FE9EB": "103",
  F0651DE961: "104",
  "004019E9B0": "105",
  "706D1BE9EF": "106",
  "802D1DE959": "107",
  "10E518E904": "108",
  A0141CE941: "109",
  "800319E973": "110",
  "50361AE995": "111",
  "50F519E955": "112",
  E0851CE990: "113",
  "70BE1AE93D": "114",
  D0101EE937: "115",
  A0A41FE9F2: "116",
  "32ABDEF6B1": "117",
  "62B2DEF6F8": "118",
  "229CDEF696": "119",
  B2ACDEF636: "120",
  "3296DEF68C": "121",
  E2B3DEF679: "122",
  "52A4DEF6DE": "123", // new
  "82B3DEF619": "124",
  "62ABDEF6E1": "125",
  "52ACDEF6D6": "126",
  E2A4DEF66E: "127",
  D2BCDEF646: "128",
  "92A3F619DE": "129",
  A2C0DEF64A: "130",
  C29BDEF671: "131",
  "82A4DEF60E": "132",
  F2A3DEF679: "133",
  "52B3DEF6C9": "134",
  "429ADEF6F0": "135",
  "82ACDEF606": "136",
  "22B3DEF6B9": "137",
  "52AADEF6D0": "138",
  F29BDEF641: "139",
  B29CDEF606: "140",
  C2ABDEF641: "141",
  "62BBDEF6F1": "142",
  "02A3DEF689": "143",
  "8299DEF633": "144",
  "929BF621DE": "145",
  C2B9DEF653: "146",
  "1277DEF64D": "147",
  "62A3DEF6E9": "148",
  "12B4DEF68E": "149",
  "52A9DEF6D3": "150",
  "92BBF601DE": "151",
  "92C4F67EDE": "152",
  "22A9DEF6A3": "153",
  F2BBDEF661: "154",
  "5299DEF6E3": "155",
  C296DEF67C: "156",
  E2A2DEF668: "157",
  A2B4DEF63E: "158",
  "5295DEF6EF": "159",
  F2B9DEF663: "160",
  D2B4DEF64E: "161",
  "829CDEF636": "162",
  "52BCDEF6C6": "163",
  "82BCDEF616": "164",
  "22BCDEF6B6": "165",
  "32B9DEF6A3": "166",
  "22BADEF6B0": "167",
  "22A4DEF6AE": "168",
  B2BADEF620: "169",
  "62C4DEF68E": "170",
  C2BBDEF651: "171",
  "92ABF611DE": "172",
  "0270DBF65F": "173", //new
  F294DEF64E: "174",
  "72A1DEF6FB": "175",
  "6278DEF632": "176",
  "32BBDEF6A1": "177",
  "02BBDEF691": "178",
  "02B2DEF698": "179",
  "329BDEF681": "180",
  "8295DEF63F": "181",
  "22AADEF6A0": "182",
  E276DEF6BC: "183",
  "2299DEF693": "184",
  A29ADEF610: "185",
  C2A9DEF643: "186",
  D27EDEF684: "187",
  C2C4DEF62E: "188",
  B276DEF6EC: "189",
  "0278DEF652": "190",
  C294DEF67E: "191",
  "8276DEF6DC": "192",
  C2B2DEF658: "193",
  F2A9DEF673: "194",
  "3278DEF662": "195",
  "729ADEF6C0": "196", //new
  "42B4DEF6DE": "197",
  B2A4DEF63E: "198",
  "22ACDEF6A6": "199",
  "129BDEF6A1": "200",
  "32A3DEF6B9": "201",
  "529CDEF6E6": "202",
  D295DEF66F: "203",
  E2ACDEF666: "204",
  "72B4DEF6EE": "205",
  "02ABDEF681": "206",
  C2A3DEF649: "207",
  F2ABDEF671: "208",
  E2BADEF670: "209",
  A26FDEF6E5: "210",
  "6270DEF63A": "211",
  "92B9F603DE": "212",
  E26EDEF6A4: "213",
  "92B2F608DE": "214",
  C26EDEF684: "215",
  B295DEF60F: "216",
  F2A1DEF67B: "217",
  "027FDEF655": "218",
  "129ADEF6A0": "219",
  "927FF6C5DE": "220",
  "327FDEF665": "221",
  "12A1DEF69B": "222",
  B2A2DEF638: "223",
  "82BADEF610": "224",
  "12B1DEF68B": "225",
  "426FDEF605": "226",
  B2B3DEF629: "227",
  "9296F62CDE": "228",
  B299DEF603: "229",
  "629BDEF6D1": "230",
  A27EDEF6F4: "231",
  "4277DEF61D": "232",
  "3270DEF66A": "233",
  "726FDEF635": "234",
  A277DEF6FD: "235",
  B2AADEF630: "236",
  D2B1DEF64B: "237", // new
  "52BADEF6C0": "238",
  A2B1DEF63B: "239",
  "22A2DEF6A8": "240",
  E2AADEF660: "241",
  "9268F6D2DE": "242",
  "0270DEF65A": "243",
  "32B2DEF6A8": "244",
  "7277DEF62D": "245",
  "126FDEF655": "246",
  "62C2DEF688": "247",
  "02B9DEF693": "248",
  "627FDEF635": "249",
  "82A9DEF603": "250",
  "92C2F678DE": "251",
  C2C2DEF628: "252",
  "62B9DEF6F3": "253",
  D26FDEF695: "254",
  "0296DEF6BC": "255",
  "82A2DEF608": "256",
  "6296DEF6DC": "257",
  "52A2DEF6D8": "258",
  "42B1DEF6DB": "259",
  "72B1DEF6EB": "260",
  "82AADEF600": "261",
  "92A1F61BDE": "262",
  "42A1DEF6CB": "263",
  "6268DEF622": "264",
  "3268DEF672": "265",
  D277DEF68D: "266",
  F2B2DEF668: "267",
  E299DEF653: "268",
  C2A1DEF64B: "269",
  C29ADEF670: "270",
};

const cartridgeMapRev = {
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  10: "10",
  11: "11",
  12: "12",
  13: "13",
  14: "14",
  15: "15",
  16: "16",
  17: "17",
  18: "18",
  19: "19",
  20: "20",
};

class ShowAddedMedicines extends Component {
  state = {
    doseInfo: "",
    doseFrequency: "",
    dosage_direction: "",
    data: {},
    editMedModal: "",
    medTableLoading: false,
    dataForEdit: {},
    selectedRowKeys: [],
    doctorMedLinkUpModal: false,
  };

  showEditMedModal = (indexId) => {
    const { medicineList } = this.props;
    const data = medicineList.filter((med, index) => index === indexId);
    this.setState({
      editMedModal: indexId,
      dataForEdit: data[0],
    });
  };

  handleEditMedCancel = () => {
    this.setState({ editMedModal: false });
  };

  saveFormRefMed = (formRef) => {
    this.formRefMed = formRef;
  };

  handleEditMedCreate = () => {
    const { form } = this.formRefMed.props;
    form.validateFields((err, values) => {
      if (err) {
        console.log(err);
        return;
      }
      console.log(values);
    });
  };

  extendMedicineDate = (indexId) => {
    const { medicineList, end_date, pushMedAtIndexOf } = this.props;

    this.setState({ medTableLoading: true });

    const data = medicineList.filter((med, index) => index === indexId);

    const values = data[0];

    values.end_date = end_date;

    if (values.id !== undefined) {
      // make use of id to submit directly to database
      axios({
        method: "put",
        url: `/prescription_medicines/${values.id}.json`,
        headers: { Authorization: sessionStorage.getItem("jwtToken") },
        data: {
          prescription_medicine: {
            end_date: values.end_date,
          },
        },
      }).then((response) => {
        pushMedAtIndexOf(indexId, response.data);
        this.setState({ medTableLoading: false });
      });
    }
  };

  showStopConfirm = (indexId) => {
    const { medicineList, pushMedAtIndexOf } = this.props;

    confirm({
      title: "Do you want to stop this medicine?",
      content: "Sets end-date to today",
      onOk: () => {
        this.setState({ medTableLoading: true });
        const data = medicineList.filter((med, index) => index === indexId);
        const values = data[0];
        // console.log('hello');
        values.end_date = moment().format("YYYY-MM-DD");

        // console.log(values.end_date);

        if (values.id !== undefined) {
          // make use of id to submit directly to database
          // console.log('running here');
          axios({
            method: "put",
            url: `/prescription_medicines/${values.id}.json`,
            headers: { Authorization: sessionStorage.getItem("jwtToken") },
            data: {
              prescription_medicine: {
                end_date: values.end_date,
              },
            },
          }).then((response) => {
            console.log(response.data);
            pushMedAtIndexOf(indexId, response.data);
            this.setState({ medTableLoading: false });
          });
        }
      },
      onCancel: () => {},
    });
  };

  deleteAddedMedicine = async (countId, id) => {
    // this.props.deleteMedicineFromMedicineList(id);
    const { deleteMedicineFromMedicineList } = this.props;
    // console.log(countId, id);
    this.setState({ medTableLoading: true });
    await axios({
      method: "delete",
      url: `/prescription_medicines/${id}.json`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then(() => {
      deleteMedicineFromMedicineList(countId);
      this.setState({ medTableLoading: false });
    });
  };

  handleSendMed = (event) => {
    event.preventDefault();

    const {
      order_id,
      medicineList,
      resetOrderDetail,
      history,
      p_prescriptions_url,
    } = this.props;

    const lolol = [];

    /* eslint-disable */
    medicineList.map((med) => {
      delete med.id;
      lolol.push(med);
    });

    // console.log(lolol);

    axios({
      method: "post",
      url: "/e_prescriptions.json",
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
      data: {
        e_prescription: {
          order_id,
          prescription_medicines: lolol, //  structure is - [{},{}] - this is fine.
          p_prescriptions: p_prescriptions_url, //  structure is - [{"photo_link": ''},{"photo_link": ''}]
        },
      },
    })
      .then(() => {
        resetOrderDetail();
        history.push("/allOrders");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleDoseInfo = (values) => {
    this.setState({ doseInfo: values });
  };

  handleDoseDirection = (values) => {
    this.setState({ dosageDirection: values });
  };

  handleDoseFrequency = (values) => {
    this.setState({ doseFrequency: values });
  };

  handleSubmitFromDosageDirection = (values) => {
    const { dataForEdit, doseInfo } = this.state;
    const { medicineList, pushMedAtIndexOf, e_prescription_id } = this.props;
    // console.log(e_prescription_id === "");
    // this.state.dataForEdit.id is undefined when no id
    if (e_prescription_id !== "" || e_prescription_id == null) {
      // make use of id to submit directly to database
      axios({
        method: "put",
        url: `/prescription_medicines/${dataForEdit.id}.json`,
        headers: { Authorization: sessionStorage.getItem("jwtToken") },
        data: {
          prescription_medicine: {
            ...doseInfo,
            ...values,
          },
        },
      }).then(() => {
        // first delete from medList based on the medicine_id and then add it to the database
        // deleting first
        const indexId = medicineList.indexOf(dataForEdit);
        // console.log(indexId);

        const data = {
          id: dataForEdit.id,
          medicine_id: dataForEdit.medicine_id,
          name: dataForEdit.name,
          ...doseInfo,
          ...values,
          frequency: dataForEdit.frequency,
          doctor_id: dataForEdit.doctor_id,
          month_days: dataForEdit.month_days,
          week_days: dataForEdit.week_days,
          day_num: dataForEdit.day_num,
          option_type: dataForEdit.option_type,
          month_day_occurrence: dataForEdit.month_day_occurrence,
          url: dataForEdit.url,
          start_date: dataForEdit.start_date,
          end_date: dataForEdit.end_date,
        };

        pushMedAtIndexOf(indexId, data);
        window.location.reload();
      });
    } else {
      // first delete from medList based on the medicine_id and then add it to the database
      // deleting first
      const indexId = medicineList.indexOf(dataForEdit);

      const data = {
        medicine_id: dataForEdit.medicine_id,
        doctor_id: dataForEdit.doctor_id,
        name: dataForEdit.name,
        ...doseInfo,
        ...values,
        frequency: dataForEdit.frequency,
        month_days:
          dataForEdit.month_days == null ? "" : dataForEdit.month_days,
        week_days: dataForEdit.week_days == null ? "" : dataForEdit.week_days,
        day_num: dataForEdit.day_num == null ? "" : dataForEdit.day_num,
        month_day_occurrence:
          dataForEdit.month_day_occurrence == null
            ? ""
            : dataForEdit.month_day_occurrence,
        start_date:
          dataForEdit.start_date == null ? "" : dataForEdit.start_date,
        end_date: dataForEdit.end_date == null ? "" : dataForEdit.end_date,
      };

      pushMedAtIndexOf(indexId, data);
      window.location.reload();
    }
  };

  handleMedicineTenure = (values) => {
    // console.log(values);

    const { dataForEdit, doseInfo, doseFrequency, dosageDirection } =
      this.state;

    const { e_prescription_id } = this.props;

    const medTenure = values;

    const { medicineList, pushMedAtIndexOf } = this.props;
    // this.state.dataForEdit.id is undefined when no id
    if (e_prescription_id !== "" || e_prescription_id == null) {
      // make use of id to submit directly to database
      axios({
        method: "put",
        url: `/prescription_medicines/${dataForEdit.id}.json`,
        headers: { Authorization: sessionStorage.getItem("jwtToken") },
        data: {
          prescription_medicine: {
            ...doseInfo,
            ...doseFrequency,
            ...dosageDirection,
            ...medTenure,
          },
        },
      }).then(() => {
        // console.log(response);
        // first delete from medList based on the medicine_id and then add it to the database
        // deleting first
        const indexId = medicineList.indexOf(dataForEdit);
        // console.log(indexId);

        const data = {
          id: dataForEdit.id,
          medicine_id: dataForEdit.medicine_id,
          name: dataForEdit.name,
          doctor_id: dataForEdit.doctor_id,
          ...doseInfo,
          ...doseFrequency,
          ...dosageDirection,
          ...medTenure,
        };

        pushMedAtIndexOf(indexId, data);
        window.location.reload();
      });
    } else {
      // first delete from medList based on the medicine_id and then add it to the database
      // deleting first
      const indexId = medicineList.indexOf(dataForEdit);

      const data = {
        medicine_id: dataForEdit.medicine_id,
        name: dataForEdit.name,
        doctor_id: dataForEdit.doctor_id,
        ...doseInfo,
        ...doseFrequency,
        ...dosageDirection,
        ...medTenure,
      };

      pushMedAtIndexOf(indexId, data);
      window.location.reload();
    }
  };

  showDocMedLinkUp = () => {
    this.setState({
      doctorMedLinkUpModal: true,
    });
  };

  handleDocMedLinkUpCancel = () => {
    this.setState({
      doctorMedLinkUpModal: false,
    });
  };

  render() {
    const {
      order_id,
      medicineList,
      e_prescription_id,
      deleteMedicineFromMedicineList,
      history,
      filter,
      toggleFilter,
    } = this.props;
    const { dataForEdit, medTableLoading, editMedModal, doctorMedLinkUpModal } =
      this.state;
    const { medicine_id, name, salt, price, form } = dataForEdit;

    console.log(moment("2019-02-02", "YYYY-MM-DD") < moment());

    return (
      <div style={{ width: "98%", margin: "auto", marginTop: "2%" }}>
        <Row type="flex" justify="center">
          <Col span={4}>
            <h2 style={{ textAlign: "center" }}>Medicines in {order_id}</h2>
          </Col>
          <Col span={4}>
            <p style={{ fontSize: "30" }}>
              <strong>Filter </strong>
            </p>
            <Switch value={filter} onChange={toggleFilter} />
          </Col>
        </Row>

        <hr width="100px" />

        <Table
          className="mainTable"
          dataSource={
            filter
              ? medicineList.filter((med) => {
                  if (med.end_date === "" || med.end_date === null) {
                    return true;
                  } else {
                    return moment(med.end_date, "YYYY-MM-DD") > moment();
                  }
                })
              : medicineList
          }
          scroll={{ x: 3025 }}
          loading={medTableLoading}
          size="middle"
          rowKey="id"
          style={{ overflow: "wrap" }}
        >
          <Column
            title="# med"
            width={75}
            fixed="left"
            align="center"
            render={(record) => medicineList.indexOf(record) + 1}
          />
          <Column
            title="Name"
            dataIndex="name"
            width={200}
            fixed="left"
            align="center"
          />
          <Column
            title="Cartridge ID"
            width={250}
            // align="center"
            // dataIndex="id"
            render={(record) => {
              console.log(record.cartridge_id);
              let cartridge_id = record.cartridge_id;
              if (cartridge_id == null) {
                return <Tag color="red">No cartridge</Tag>;
              } else if (cartridge_id == "") {
                return <Tag color="red">No cartridge</Tag>;
              } else {
                return cartridge_id.toString().length > 3
                  ? cartridgeMapRevRFID[cartridge_id].toString() +
                      " " +
                      "(RFID)"
                  : cartridgeMapRev[cartridge_id].toString() + " " + "(Slot)";
              }
            }}
          />
          <Column
            style={{ wordBreak: "keep-all" }}
            title="DQ"
            dataIndex="quantity"
            width={100}
            align="center"
          />
          <Column title="Form" dataIndex="form" width={100} align="center" />
          <Column
            title="Doctor ID"
            dataIndex="doctor_id"
            width={150}
            align="center"
          />
          <Column
            title="Start"
            dataIndex="start_date"
            width={150}
            align="center"
          />
          <Column
            title="End"
            // dataIndex="end_date"
            render={(record) =>
              moment(record.end_date).isValid() ? record.end_date : "–"
            }
            width={150}
            align="center"
          />
          <Column
            title="Duration(days)"
            render={(record) => {
              const start = moment(record.start_date);
              const end = moment(record.end_date);
              return (
                <p>
                  {isNaN(end.diff(start, "days") + 1)
                    ? "–"
                    : end.diff(start, "days") + 1}
                </p>
              );
            }}
            width={150}
            align="center"
          />
          <Column
            title="DD"
            dataIndex="dosage_direction"
            width={150}
            align="center"
          />
          <Column
            title="T1"
            dataIndex="time_1"
            align="center"
            width={100}
            style={{ wordBreak: "break-word" }}
          />
          <Column
            title="D1"
            dataIndex="direction_1"
            align="center"
            width={100}
            style={{
              wordBreak: "break-word",
              overflow: "wrap",
              whiteSpace: "unset",
            }}
          />
          <Column title="T2" dataIndex="time_2" width={100} align="center" />
          <Column
            title="D2"
            dataIndex="direction_2"
            width={100}
            align="center"
          />
          <Column title="T3" dataIndex="time_3" width={100} align="center" />
          <Column
            title="D3"
            dataIndex="direction_3"
            width={100}
            align="center"
          />
          <Column title="T4" dataIndex="time_4" width={100} align="center" />
          <Column
            title="D4"
            dataIndex="direction_4"
            width={100}
            align="center"
          />
          <Column
            title="Freq"
            dataIndex="frequency"
            width={50}
            align="center"
          />
          <Column
            title="M D"
            dataIndex="month_days"
            width={100}
            align="center"
          />
          <Column
            title="W D"
            dataIndex="week_days"
            width={100}
            align="center"
          />
          <Column
            title="Actions"
            fixed="right"
            width={250}
            // align="center"
            // dataIndex="id"
            render={(record) => (
              <span>
                {e_prescription_id !== "" ? (
                  <span>
                    <Tooltip placement="top" title="Stop Medicine">
                      <span>
                        <Button
                          type="primary"
                          icon="poweroff"
                          shape="circle"
                          onClick={() =>
                            this.showStopConfirm(medicineList.indexOf(record))
                          }
                          disabled={moment(record.end_date) <= moment()}
                        />
                      </span>
                    </Tooltip>

                    <Divider type="vertical" />

                    <Tooltip placement="top" title="Extend Medicine">
                      <span>
                        <Button
                          type="primary"
                          icon="reload"
                          shape="circle"
                          onClick={() =>
                            this.extendMedicineDate(
                              medicineList.indexOf(record)
                            )
                          }
                        />
                      </span>
                    </Tooltip>

                    <Divider type="vertical" />
                  </span>
                ) : null}

                <Tooltip placement="top" title="Edit Medicine">
                  <span>
                    <Button
                      type="primary"
                      icon="edit"
                      shape="circle"
                      onClick={() =>
                        this.showEditMedModal(medicineList.indexOf(record))
                      }
                    />
                    <MedInfoModal
                      visible={editMedModal === medicineList.indexOf(record)}
                      onCancel={this.handleEditMedCancel}
                      data={dataForEdit}
                      selectedMed={`${medicine_id}#${name}#${salt}#${price}#${form}`}
                      handleDoseInfo={this.handleDoseInfo}
                      handleDoseDirection={this.handleDoseDirection}
                      handleDoseFrequency={this.handleDoseFrequency}
                      handleSubmitFromDosageDirection={
                        this.handleSubmitFromDosageDirection
                      }
                      handleMedicineTenure={this.handleMedicineTenure}
                    />
                  </span>
                </Tooltip>

                <Divider type="vertical" />

                <Tooltip placement="top" title="Delete this medicine">
                  <span>
                    {e_prescription_id === "" ? (
                      <Button
                        type="danger"
                        shape="circle"
                        icon="delete"
                        onClick={() =>
                          deleteMedicineFromMedicineList(
                            medicineList.indexOf(record)
                          )
                        }
                      />
                    ) : (
                      <Button
                        type="danger"
                        shape="circle"
                        icon="delete"
                        onClick={() =>
                          this.deleteAddedMedicine(
                            medicineList.indexOf(record),
                            record.id
                          )
                        }
                      />
                    )}
                  </span>
                </Tooltip>
              </span>
            )}
          />
        </Table>

        <div style={{ marginTop: "5%" }}>
          <Button type="primary" onClick={this.showDocMedLinkUp}>
            Add Doctor
          </Button>

          <DoctorMedLinkUpModal
            visible={doctorMedLinkUpModal}
            onCancel={this.handleDocMedLinkUpCancel}
          />

          {/* TODO - remove this after adding doctors page */}
          {e_prescription_id === "" ? (
            <Button type="primary" onClick={this.handleSendMed}>
              Submit Medicines
            </Button>
          ) : (
            <Button type="primary" onClick={() => history.push("/allOrders")}>
              Done
            </Button>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  filter: state.AppState.filter,
  medicineList: state.AppState.medicineList,
  order_id: state.AppState.order_id,
  user_id: state.AppState.user_id,
  doctor_id: state.AppState.doctor_id,
  photo_link: state.AppState.photo_link,
  start_date: state.AppState.start_date,
  end_date: state.AppState.end_date,
  e_prescription_id: state.AppState.ep_id,
  p_prescriptions_url: state.AppState.p_prescriptions_url,
});

const mapDispatchToProps = (dispatch) => ({
  addMedicineToMedicineList: (medicine) =>
    dispatch({ type: ADD_MEDICINE_TO_LIST, medicine }),
  deleteMedicineFromMedicineList: (id) =>
    dispatch({ type: DELETE_MEDICINE_FROM_LIST, id }),
  pushMedAtIndexOf: (id, data) =>
    dispatch({ type: PUSH_MED_AT_INDEX_OF, payload: { id, data } }),
  resetOrderDetail: () => dispatch({ type: RESET_ORDER_DETAIL }),
  toggleFilter: () => dispatch({ type: TOGGLE_FILTER }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ShowAddedMedicines));



// WEBPACK FOOTER //
// ./src/component/AddingMedToOrder/ShowAddedMedicines.js